// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAKRAsSOE-gK1hs3IsQIaW6x7Hm7PvsHx4",
  authDomain: "fopprdev.firebaseapp.com",
  projectId: "fopprdev",
  storageBucket: "fopprdev.firebasestorage.app",
  messagingSenderId: "981812302356",
  appId: "1:981812302356:web:fc16e210cc58fe4eda8d01",
  measurementId: "G-Q1Q4JRL9GB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// eslint-disable-next-line no-unused-vars
const analytics = getAnalytics(app);
const db = getFirestore(app);

export {db};